import { useEffect, useRef } from "react";

export default function useTimer({
  isRunning,
  canRun,
  activeCounterId,
  onTick,
}) {
  const timerRef = useRef(null);

  useEffect(() => {
    // Start timer
    if (isRunning && canRun) {
      timerRef.current = setInterval(() => {
        onTick(activeCounterId);
      }, 1000);
    } else {
      // Stop timer
      clearInterval(timerRef.current);
    }

    // Cleanup on unmount or dependency change
    return () => {
      clearInterval(timerRef.current);
    };
  }, [isRunning, canRun, activeCounterId, onTick]);
}